import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NetscopeModule } from "./netscope/netscope.module";
import {NetscopeApiService} from "@app/services/netscope-api.service";
import {TranslocoRootModule} from "@app/transloco-root/transloco-root.module";
import {DcnetscopeMainComponent} from "@app/dcnetscope-main/dcnetscope-main.component";
import {SelectionComboboxComponent} from "@app/selection-combobox/selection-combobox.component";
import {ClarityModule, ClrComboboxModule} from "@clr/angular";
import {FormsModule} from "@angular/forms";
import {FortinetNavComponent} from "@app/fortinet/fortinet-nav.component";
import {ThemeScheduleComponent} from "@app/dcnetscope-main/theme-schedule/theme-schedule.component";

import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';

// To fix errors "Property 'msSaveBlob' does not exist on type 'Navigator'."
// that appears in newer version of angular/clarity.
declare global {
    interface Navigator {
        msSaveBlob: (blob: Blob, fileName: string) => boolean
    }
}

// function initializeKeycloak(keycloak: KeycloakService) {
//   return () =>
//     keycloak.init({
//       config: {
//         url: 'http://192.168.3.73:8080',
//         realm: 'users',
//         clientId: 'dcnetscope'
//       },
//       initOptions: {
//         onLoad: 'check-sso',
//         silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
//         checkLoginIframe: false
//       }
//     });
// }


@NgModule({
    declarations: [
        AppComponent,
        DcnetscopeMainComponent,
        SelectionComboboxComponent,
        // TimeSelectionHeatmapComponent
    ],
    imports: [
        ClarityModule,
        FormsModule,
        ClrComboboxModule,
        BrowserModule,
        AppRoutingModule,
        NetscopeModule,
        TranslocoRootModule,
        KeycloakAngularModule,
        // the menu of the Fortinet pages, shown by DcnetscopeMainComponent
        FortinetNavComponent,
        // the automatic theme switch dialog, opened from the settings dropdown of DcnetscopeMainComponent
        ThemeScheduleComponent
    ],
    providers: [
        NetscopeApiService,
        // {
        //   provide: APP_INITIALIZER,
        //   useFactory: initializeKeycloak,
        //   multi: true,
        //   deps: [KeycloakService]
        // }
    ],
    exports: [
        SelectionComboboxComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
